(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('required-size-selection')) {
  customElements.define('required-size-selection', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.shopify-section, dialog');
      if (!this.scope) return;
      this.choice = '';
      this.controller = new AbortController();
      this.sync = () => {
        const picker = this.scope.querySelector('variant-picker[data-block-id="' + this.dataset.blockId + '"]');
        const select = picker?.querySelector('select[data-required-size]');
        if (!select) return;
        const option = Array.from(select.options).find(item => item.value === this.choice);
        if (!option) this.choice = '';
        if (select.value !== this.choice) select.value = this.choice;
        for (const item of select.options) {
          if (item.selected !== item.hasAttribute('selected')) item.toggleAttribute('selected', item.selected);
        }
        const stickySelect = this.scope.querySelector('sticky-add-to-cart[data-product-id="' + this.dataset.productId + '"] select[data-sticky-size]');
        if (stickySelect && stickySelect.value !== this.choice) stickySelect.value = this.choice;
        const pending = !this.choice;
        this.scope.toggleAttribute('data-size-selection-pending', pending);
        const productId = this.dataset.productId;
        const buttons = this.scope.querySelectorAll('product-form-component[data-product-id="' + productId + '"] [ref="addToCartButton"], sticky-add-to-cart[data-product-id="' + productId + '"] [ref="addToCartButton"]');
        for (const button of buttons) {
          if (pending) {
            if (!button.hasAttribute('data-size-locked')) button.dataset.sizeLocked = String(button.disabled);
            if (!button.disabled) button.disabled = true;
          } else if (button.hasAttribute('data-size-locked')) {
            const wasDisabled = button.dataset.sizeLocked === 'true';
            button.removeAttribute('data-size-locked');
            if (!wasDisabled) button.disabled = false;
          }
        }
      };
      this.scope.addEventListener('change', event => {
        const select = event.target;
        if (!(select instanceof HTMLSelectElement)) return;
        if (select.matches('[data-sticky-size]')) {
          const mainSelect = this.scope.querySelector('variant-picker[data-block-id="' + this.dataset.blockId + '"] select[data-required-size]');
          if (mainSelect) {
            mainSelect.value = select.value;
            mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }
        if (!select.matches('[data-required-size]')) return;
        if (select.closest('variant-picker')?.dataset.blockId !== this.dataset.blockId) return;
        this.choice = select.value;
        this.sync();
      }, { capture: true, signal: this.controller.signal });
      this.scope.addEventListener('submit', event => {
        if (this.choice || !event.target.closest('product-form-component[data-product-id="' + this.dataset.productId + '"]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.scope.querySelector('select[data-required-size]')?.focus();
      }, { capture: true, signal: this.controller.signal });
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
